import { __ } from "@wordpress/i18n";
import apiFetch from '@wordpress/api-fetch';
import React, { useEffect, useState } from 'react';
import DataTable from 'react-data-table-component';
import deleteIcon from '../assets/images/delete.svg';
import resetIcon from '../assets/images/reset.svg';
import withForm from '../pages/withForm';
const Security2faList = ({handleChange}) => {
    const [selectedRows, setSelectedRows] = useState([])
    const [bulkAction, setBulkAction] = useState("-1")
    const [userList,setUserList] = useState([])
    const [records, setRecords] = useState([])
    const [roleList,setRoleList] = useState([])
    const [activeRole, setActiveRole] = useState('')
    const [searchQuery,setSearchQuery] = useState('')
    const columns =  [
        { 
            id: 'username',
            name: 'Username',
            cell: row => (
                <div className="d-flex flex-wrap align-items-center gap-2">
                    <img src={row.data.avatar} alt={row.data.display_name} width="40" height="40" />
                    <span><b>{row.data.user_login}</b></span>
                </div>
            ),

        },
        {
            id: 'user_registered',
            name: 'Created Date',
            selector: row => row.data.user_registered,
            sortable: true,
        },
        { 
            id: 'usfw-2fa-provider',
            name: '2FA Type',
            selector: row => row.data.user_meta['usfw-2fa-provider']?row.data.user_meta['usfw-2fa-provider']:'N/A',
            sortable: true,
        },
        { 
            id: 'action',
            name: 'Action',
            cell: row => (
                <div className="d-flex align-items-center gap-2">
                    <img
                        src={resetIcon}
                        className="cursor-pointer"
                        onClick={() => handleClick2faReset(row.ID)}
                    />
                    <img
                        src={deleteIcon}
                        className="cursor-pointer"
                        onClick={() => handleClick2faDelete(row.ID)}
                    />
                </div>
            ),
            ignoreRowClick: true, // Prevent triggering row click event
            allowoverflow: true, // Ensure it doesn’t interfere with other UI
            button: true, // Ensures proper styling for buttons

            style: {display: 'flex', justifyContent: 'end', paddingRight: '11px', gap: '8px'}
        }
    ]

    useEffect(() => {
        const baseURL = '/ultimate-security/v1';        

        const getRoleData = async () => {
            try {
                const response = await apiFetch({
                    path: `${baseURL}/get-roles`,
                    method: 'GET'
                });

                const rolesArray = Object.entries(response).map(([key, value]) => ({
                    role: key,
                    ...value
                }));
                
                setRoleList(rolesArray);

            } catch (error) {
                console.log(error);
            }
        };
        getRoleData();
    },[])
    
    useEffect(() => {
        const baseURL = '/ultimate-security/v1';        
        const getUserData = async () => {
            try {
                const response = await apiFetch({
                    path: `${baseURL}/get-users`,
                    method: 'GET'
                });
        
                setUserList(response);
                setRecords(response);
        
            } catch (error) {
                console.log(error);
            }
        };
        getUserData();
    },[])

    const handleSelectedRowsChange = ({ selectedRows }) => {
        setSelectedRows(selectedRows);
        // console.log(selectedRows)
    };
    const handleUserSearch = (e) => {
        setSearchQuery(e.target.value)
        setActiveRole('') // Reset the active role
        const newData = userList.filter(row => {
            return row.data.user_login.toLowerCase().includes(e.target.value.toLowerCase())
        })
        setRecords(newData)
    }
    const handleUserFilter = (role) => {
        setSearchQuery('')
        if (role == 'All') {
            setRecords(userList)        
            setActiveRole(''); // Set the active role
        } else {
            const newData = userList.filter(row => {
                return row.data.role.toLowerCase().includes(role.toLowerCase())
            })
            setRecords(newData)        
            setActiveRole(role); // Set the active role
        }
    }
    const handleClick2faReset = (user_id) => {
        // console.log("Reset 2fa for: ", user_id)
        const confirmed = window.confirm(__('Are you sure you want to proceed?', 'ultimate-security'));
        if (confirmed) {
            apiService.formDataPost('plulsc_user_2fa_reset',{"user_id": user_id})
            .then(data=> {
                // setForceLogoutLoading(false)            
                if(data.success){
                    apiService.getUserList()
                    .then(data=> {
                        if(data){
                            setUserList(data)
                            setRecords(data)
                            setActiveRole('') // Reset the active role
                        }
                    })
                    .catch(err=> console.log(err))
                    console.log(data.data)
                    alert(data.data.success_message)
                } else {
                    console.log(data.data.error_message)
                }
            })
            .catch(err=> {
                // setForceLogoutLoading(false)             
                alert(data.data.error_message)
            })
        }
        
    }
    const handleClick2faDelete = (user_id) => {
        const confirmed = window.confirm(__('Are you sure you want to proceed?', 'ultimate-security'));
        if (confirmed) {
            console.log("Delete 2fa for: ", user_id)
        }
    }
    const handleClick2faResetAll = () => {
        const confirmed = window.confirm(__('Are you sure you want to proceed?', 'ultimate-security'));
        if (confirmed) {
            apiService.formDataPost('plulsc_user_2fa_reset_all', {})
            .then(data=> {
                console.log(data)
                // setForceLogoutLoading(false)            
                if(data.success){
                    setBulkAction("-1")
                    setSelectedRows([])

                    apiService.getUserList()
                    .then(data=> {
                        if(data){
                            setUserList(data)
                            setRecords(data)
                            setActiveRole('') // Reset the active role
                        }
                    })
                    .catch(err=> console.log(err))

                    console.log(data.data)
                    alert(data.data.success_message)
                } else {
                    console.log(data.data.error_message)
                }
            })
            .catch(err=> {
                alert(data.data.error_message)
            })
        }
    }
    const handleClick2faDeleteAll = () => {
        const confirmed = window.confirm(__('Are you sure you want to proceed?', 'ultimate-security'));
        if (confirmed) {
            console.log("Delete all 2fa")
        }
    }
    const handleBulkActionChange = (e) => {
        setBulkAction(e.target.value);
    };    
    const handleBulkActionSubmit = () => {
        if (selectedRows.length) {
            const ids = selectedRows.map(item => item.ID);           

            if (bulkAction === "reset") {
                console.log("Reset these ids", ids)
                apiService.formDataPost('plulsc_user_2fa_reset_users',{"user_ids": ids})
                .then(data=> {
                    console.log(data)
                    // setForceLogoutLoading(false)            
                    if(data.success){
                        setBulkAction("-1")
                        setSelectedRows([])

                        apiService.getUserList()
                        .then(data=> {
                            if(data){
                                setUserList(data)
                                setRecords(data)
                                setActiveRole('') // Reset the active role
                            }
                        })
                        .catch(err=> console.log(err))

                        console.log(data.data)
                        alert(data.data.success_message)
                    } else {
                        console.log(data.data.error_message)
                    }
                })
                .catch(err=> {
                    // setForceLogoutLoading(false)             
                    alert(data.data.error_message)
                })

            } else if (bulkAction === "delete") {
                console.log("Delete these ids", ids)

            } else {
                alert("Please select a valid action.");
            }
        } else {
            alert("Please select users.");
        }
    };
    return (
        <>
            <div className="setting-unit">
            <div className="user-datatable datatable-unit">
            <div className="row justify-content-between mb-30">
                <div className="col-8 filters">
                    <div className="d-flex flex-wrap wp-roles">
                        <span
                            onClick={() => handleUserFilter('All')}
                            className={activeRole === '' ? 'active' : ''} // Apply active class conditionally
                            >All</span>
                        {
                            roleList && roleList.map(item=> (                                        
                                item?.count ? 
                                <span 
                                    key={item.role} 
                                    value={item.role} 
                                    onClick={() => handleUserFilter(item.name)}
                                    className={activeRole === item.name ? 'active' : ''} // Apply active class conditionally
                                >
                                {item.name} ({item.count})
                                </span> 
                                : ''                                        
                            ))      
                        }
                    </div>
                    <div className="bulk-action-wrapper">
                        <select value={bulkAction} name="action"  onChange={handleBulkActionChange}>
                            <option value="-1">{__( 'Bulk actions', 'ultimate-security' )}</option>
                            <option value="reset">{__( 'Reset', 'ultimate-security' )}</option>
                            <option value="delete">{__( 'Delete', 'ultimate-security' )}</option>
                        </select>
                        <button className="button button-secondary" onClick={handleBulkActionSubmit}>Apply</button>
                    </div>
                </div>
                <div className="col-auto">
                    <div className="search-unit d-flex gap-2 align-items-center">
                        <input placeholder="Search Users" type="search" onChange={handleUserSearch} value={searchQuery} />
                        <button className="button button-secondary" type="button">{__( 'Search', 'ultimate-security' )}</button>
                    </div>
                    <div className="action-buttons d-flex align-items-center">
                        <span onClick={handleClick2faResetAll}>{__( 'Reset All 2FA', 'ultimate-security' )}</span>
                        <span onClick={handleClick2faDeleteAll}>{__( 'Delete All 2FA', 'ultimate-security' )}</span>
                    </div>
                </div>
            </div>            
            <div className="table-wrapper">
                <DataTable
                    columns={columns}
                    data={records}
                    selectableRows // for making row selectable
                    onSelectedRowsChange={handleSelectedRowsChange} // Handle row selection changes  
                    pagination
                    dense
                    responsive
                />
            </div> 
        </div> 
            </div>
        </>
    )
}
export default withForm(Security2faList);